// 系统管理
import Cookies from 'js-cookie'

export const system = '/s'

// 会员用户
export const member = '/m'

// 医生用户
export const doctor = '/d'

// 会员或医生
export const md = '/md'

// 会员或运营人员
export const ms = '/ms'

// 医生或运营人员
export const ds = '/ds'

// 会员或医生或运营人员
export const mds = '/mds'

// 接口调用者
export const invoker = '/i'

// 企业用户
export const cu = '/cu'

// 疾病用户
export const du = '/du'

// 实训用户
export const tu = '/tu'

export const spBase = () => {
  const idCode = Cookies.get('pc_idCode')
  return `/backend/sp/${idCode}`
}



// WEBPACK FOOTER //
// ./src/api/common/index.js